import {useQuery} from "@tanstack/react-query";
import {readExchangeRateUnitSelectBoxApi,} from "../../../../../api/correspondent/CorresspondentApi";

/**
 * 환율 단위 select box
 * @param props
 * @returns
 */
export const useReadExchangeRateUnitSelectBoxApi = () => {
    const {data} = useQuery({
        queryKey: ["readExchangeRateUnitSelectBoxApi"],
        queryFn: async () => await readExchangeRateUnitSelectBoxApi(),
        select: (res) => res?.result ?? null,
        // staleTime: 6000 * 10,
    });

    return {data};
};
